import '@fontsource-variable/inter';
import '@fontsource-variable/jetbrains-mono';
import '@fontsource/audiowide';
import './styles/theme.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { useAuthStore } from './store/auth-store';

// Restore Supabase session from localStorage AND subscribe to auth changes
// (token refresh, cross-tab sign-out) before mounting React. Top-level await
// avoids a flash of unauthenticated UI on a returning user.
await useAuthStore.getState().initialize();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
